<style lang="sass" scoped>
  .empty
    opacity: 1
    -webkit-transition: opacity 0.5s ease-in-out
    -moz-transition: opacity 0.5s ease-in-out
    -ms-transition: opacity 0.5s ease-in-out
    -o-transition: opacity 0.5s ease-in-out
    transition: opacity 0.5s ease-in-out
    top: 50%
    left: 50%
    margin-top: -50px
    margin-left: -300px
    position: absolute
    height: 100px
    width: 600px
    border-radius: 30px
    z-index: 2
    text-align: center

    h2
      font-size: 1.375rem
      font-weight: bold
      margin-bottom: 0.75rem

    h3
      font-size: 1.125rem
      font-weight: 400
      margin-bottom: 0.75rem
</style>

<template>
  <div class="empty">
    <h2>{{ __('Nenhum dado foi encontrado!') }}</h2>
    <h3>{{ this.content || __('Já tentou alterar as datas?') }}</h3>
  </div>
</template>

<script>
export default {
  props: ['content'],
};
</script>
